import { Link } from 'react-router-dom'

export default function AppFooter() {
  return (
    <div
      role="contentinfo"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 bg-white border-t border-gray-200 mt-auto"
    >
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-600">
        <Link to="/contact" className="hover:text-gray-900 transition-colors">
          Contact
        </Link>
        <span className="hidden sm:inline">•</span>
        <Link to="/privacy" className="hover:text-gray-900 transition-colors">
          Privacy Policy & Terms of Service
        </Link>
      </div>
      {/* Required attribution for the reaction emoji (public/openmoji, CC BY-SA 4.0) */}
      <div className="mt-2 text-center text-[11px] text-gray-400">
        Emoji by <a href="https://openmoji.org" target="_blank" rel="noreferrer" className="underline hover:text-gray-600">OpenMoji</a>, licensed <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noreferrer" className="underline hover:text-gray-600">CC BY-SA 4.0</a>
      </div>
    </div>
  )
}

